import { createGlobalStyle } from 'styled-components';

import background from '~/assets/background.png';
import 'react-toastify/dist/ReactToastify.css';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  html, body, #root {
    height: 100vh;
  }

  body {
    /* background: url(${background}) no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover; */

    font-family: 'Open Sans', 'Roboto',  sans-serif;
    -webkit-font-smoothing: antialiased !important;
    text-rendering: optimizeLegibility;
  }

  input, textarea, button {
    font-family: 'Open Sans', 'Roboto',  sans-serif;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 0px;
  }

  button {
    cursor: pointer;
    border: none;
  }

  /* Customizes other classes */
  .Toastify__toast-container {
    top: 15px !important;
    right: 15px !important;
    padding: 0px !important;
  }

  .Toastify__toast--success {
    background-color: #4fcda5;
  }

  .MuiPaper-rounded {
    border-radius: 0px !important;
  }
`;
